import React, { FC } from 'react';
import Online from '@/components/online/Online';
import { Medium } from '@/constants/mediums';

const ElectricityOnlinePage: FC = () => {
  return <Online medium={Medium.electricity} allowMinuteData={true} />;
};

export default ElectricityOnlinePage;
